import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/insurancechannelserv'

export default {
  state: {
    state_InsuranceChannel_AddObjResult: null,
    state_InsuranceChannel_GetAllResult: null,
    state_InsuranceChannel_SearchByNameResult: null,
    state_InsuranceChannel_GetPageResult: null,
    state_InsuranceChannel_GetDetailResult: null,
    state_InsuranceChannel_ModifyObjResult: null,
    state_InsuranceChannel_DeleteObjResult: null
  },
  mutations: {
    SET_INSURANCECHANNEL_ADDOBJ_RESULT: (state, rst) => {
      state.state_InsuranceChannel_AddObjResult = rst
    },
    SET_INSURANCECHANNEL_GETALL_RESULT: (state, rst) => {
      state.state_InsuranceChannel_GetAllResult = rst
    },
    SET_INSURANCECHANNEL_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_InsuranceChannel_SearchByNameResult = rst
    },
    SET_INSURANCECHANNEL_GETPAGE_RESULT: (state, rst) => {
      state.state_InsuranceChannel_GetPageResult = rst
    },
    SET_INSURANCECHANNEL_GETDETAIL_RESULT: (state, rst) => {
      state.state_InsuranceChannel_GetDetailResult = rst
    },
    SET_INSURANCECHANNEL_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_InsuranceChannel_ModifyObjResult = rst
    },
    SET_INSURANCECHANNEL_DELETEOBJ_RESULT: (state, rst) => {
      state.state_InsuranceChannel_DeleteObjResult = rst
    }
  },
  actions: {
    InsuranceChannelServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSURANCECHANNEL_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSURANCECHANNEL_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InsuranceChannelServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSURANCECHANNEL_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSURANCECHANNEL_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InsuranceChannelServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSURANCECHANNEL_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSURANCECHANNEL_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InsuranceChannelServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSURANCECHANNEL_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSURANCECHANNEL_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InsuranceChannelServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSURANCECHANNEL_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSURANCECHANNEL_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InsuranceChannelServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSURANCECHANNEL_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSURANCECHANNEL_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    InsuranceChannelServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_INSURANCECHANNEL_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_INSURANCECHANNEL_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_InsuranceChannel_AddObjResult: state => {
      return state.state_InsuranceChannel_AddObjResult
    },
    get_InsuranceChannel_GetAllResult: state => {
      return state.state_InsuranceChannel_GetAllResult
    },
    get_InsuranceChannel_SearchByNameResult: state => {
      return state.state_InsuranceChannel_SearchByNameResult
    },
    get_InsuranceChannel_GetPageResult: state => {
      return state.state_InsuranceChannel_GetPageResult
    },
    get_InsuranceChannel_GetDetailResult: state => {
      return state.state_InsuranceChannel_GetDetailResult
    },
    get_InsuranceChannel_ModifyObjResult: state => {
      return state.state_InsuranceChannel_ModifyObjResult
    },
    get_InsuranceChannel_DeleteObjResult: state => {
      return state.state_InsuranceChannel_DeleteObjResult
    }
  }
}
